import {upload_attributes_files} from './uploadAttrData';
import uploadImage from './uploadImage';
import networkService from '../Network/NetworkManager';
import ToastPopup from '../HelperClasses/AppLoaderClasses/ToastPopup';
import {slug as SlugChecker} from 'github-slugger';
const APPURL = require('../Constants/URLConstants');

export const edit_account_click = async ({
  form_state,
  attributes,
  attributeData,
  setIsLoading,
  accounts_configs,
  closeModal,
  load_accounts,
  account_id,
}) => {
  try {
    setIsLoading(true);

    const {
      name,
      description,
      image_path,
      category,
      coordinates = undefined,
      full_location = undefined,
      shipping_charge = 0,
      slug,
      user_id,
    } = form_state;

    let img_resp = form_state?.image_path?.files
      ? await uploadImage({
          files: [
            {
              name: form_state?.image_path?.files.name,
              type: form_state?.image_path?.files.type,
            },
          ],
          full_files: [form_state?.image_path?.files],
        })
      : form_state?.image_path?.value
      ? [form_state?.image_path?.value]
      : undefined;

    let updated_attributes_data = attributeData?.length
      ? attributeData.find(attr => attr.uploadFile)
        ? await upload_attributes_files({
            all_attributes: attributeData,

            setIsLoading,
          })
        : attributeData
      : undefined;

    //  main functionality

    let storesData = {
      name: name,
      web_address: '',
      type: 'accounts',
    };

    if (img_resp) {
      storesData['images'] = img_resp;
    }
    if (coordinates && coordinates) {
      storesData['coordinates'] = coordinates;
    }
    if (full_location != null || full_location != undefined) {
      storesData['location'] = full_location;
    }
    if (
      category !== null &&
      !category?.toString()?.replace(/\s/g, '').length <= 0
    ) {
      storesData['category_id'] = [category];
    }
    if (attributeData?.length > 0 && updated_attributes_data) {
      storesData['attributes'] = updated_attributes_data;
    }
    if (
      accounts_configs?.accounts_show_shipping_charges &&
      shipping_charge &&
      shipping_charge > 0
    ) {
      storesData['shipping_charges'] = {
        flat: shipping_charge,
      };
    }
    // if (
    //   preferenceShippingMethod !== null &&
    //   preferenceShippingMethod?.length > 0
    // ) {
    //   storesData['shipping_methods'] = preferenceShippingMethod.map(
    //     item => item.value,
    //   );
    // }
    if (!description?.replace(/\s/g, '').length <= 0 && description !== null) {
      storesData['description'] = description;
    }
    if (!user_id?.replace(/\s/g, '').length <= 0 && user_id !== null) {
      storesData['user_id'] = user_id;
    }
    if (!slug?.replace(/\s/g, '').length <= 0) {
      storesData['slug'] = SlugChecker(slug);
    } else {
      storesData['slug'] = SlugChecker(name);
    }

    // call function
    const response = await networkService.networkCall(
      APPURL.URLPaths.accounts + account_id,
      'PUT',
      JSON.stringify({account: storesData}),
    );

    if (!response?.status) {
      setIsLoading(false);
      ToastPopup({
        type: 'error',
        message: response ?? 'Something is wrong',
      });
    } else {
      setIsLoading(false);
      closeModal();
      load_accounts();
    }
  } catch (error) {
    setIsLoading(false);
  }
};
